export const api = {
    ping: `${process.env.REACT_APP_API}/ping`,
    get_counted_bus: `${process.env.REACT_APP_API}/count_bus`,
    get_top_10_products: `${process.env.REACT_APP_API}/top_10_products`,
    get_daily_worker_graph: `${process.env.REACT_APP_API}/daily_worker_graph`,
    login: `${process.env.REACT_APP_API}/login`,
    refresh: `${process.env.REACT_APP_API}/refresh`,
    get_users: `${process.env.REACT_APP_API}/users`,
    users_excel: `${process.env.REACT_APP_API}/users/excel`,
    user: `${process.env.REACT_APP_API}/user`,
    client: `${process.env.REACT_APP_API}/clients`,
    owner: `${process.env.REACT_APP_API}/owner`,
    owner_business_profile: `${process.env.REACT_APP_API}/owner/business_profile`,
    owner_business_profile_extract: `${process.env.REACT_APP_API}/owner/business_profile/extract`,
    owner_business_profile_apply: `${process.env.REACT_APP_API}/owner/business_profile/apply`,
    owner_business_profile_skip: `${process.env.REACT_APP_API}/owner/business_profile/skip`,
    owner_business_profile_consultation: `${process.env.REACT_APP_API}/owner/business_profile/consultation`,
    owner_business_profile_seed_demo: `${process.env.REACT_APP_API}/owner/business_profile/seed_demo`,
    owner_business_profile_remove_demo: `${process.env.REACT_APP_API}/owner/business_profile/remove_demo`,
    industries: `${process.env.REACT_APP_API}/industries`,
    billing: `${process.env.REACT_APP_API}/billing`,
    get_clients: `${process.env.REACT_APP_API}/clients`,
    get_me: `${process.env.REACT_APP_API}/get_me`,
    get_roles: `${process.env.REACT_APP_API}/roles`,
    roles_excel: `${process.env.REACT_APP_API}/roles/excel`,
    role: `${process.env.REACT_APP_API}/role`,
    role_with_accesses: `${process.env.REACT_APP_API}/role_with_accesses`,
    access_groups: `${process.env.REACT_APP_API}/access_groups`,
    accesses: `${process.env.REACT_APP_API}/accesses`,
    transactions: `${process.env.REACT_APP_API}/transaction`,
    transactionsExtended: `${process.env.REACT_APP_API}/transaction_extended`,
    transaction_types: `${process.env.REACT_APP_API}/transaction_types`,
    transactions_excel: `${process.env.REACT_APP_API}/transactions_excel`,
    transaction_statuses: `${process.env.REACT_APP_API}/transaction_statuses`,
    transaction_approve: `${process.env.REACT_APP_API}/approve_transaction`,
    transaction_cancel: `${process.env.REACT_APP_API}/cancel_transaction`,
    transaction_refund: `${process.env.REACT_APP_API}/refund_transaction`,
    get_business_units: `${process.env.REACT_APP_API}/business_units`,
    business_units_excel: `${process.env.REACT_APP_API}/business_units/excel`,
    business_unit: `${process.env.REACT_APP_API}/business_unit`,
    business_service: `${process.env.REACT_APP_API}/business_services`,
    delegated_service_installments: `${process.env.REACT_APP_API}/delegated_service/installments`,
    delegated_service_operations: `${process.env.REACT_APP_API}/delegated_service/operations`,
    delegated_service_operations_excel: `${process.env.REACT_APP_API}/delegated_service/operations/excel`,
    external_payments: `${process.env.REACT_APP_API}/external_payments`,
    external_payments_excel: `${process.env.REACT_APP_API}/external_payments/excel`,
    business_stocks: `${process.env.REACT_APP_API}/business_stocks`,
    business_stocks_excel: `${process.env.REACT_APP_API}/business_stocks/excel`,
    business_stock: `${process.env.REACT_APP_API}/business_stock`,
    product: `${process.env.REACT_APP_API}/product`,
    get_products: `${process.env.REACT_APP_API}/products`,
    product_types: `${process.env.REACT_APP_API}/product_types`,
    product_brands: `${process.env.REACT_APP_API}/product_brands`,
    product_categories: `${process.env.REACT_APP_API}/product_categories`,
    product_categories_excel: `${process.env.REACT_APP_API}/product_categories/excel`,
    get_measurements: `${process.env.REACT_APP_API}/measure_units`,
    get_business_goods: `${process.env.REACT_APP_API}/business_goods`,
    get_workers_general_report: `${process.env.REACT_APP_API}/workers_general_report`,
    get_bu_general_report: `${process.env.REACT_APP_API}/bu_general_report`,
    get_profit_report: `${process.env.REACT_APP_API}/profit_report`,
    get_daily_worker_report: `${process.env.REACT_APP_API}/daily_worker_report`,
    download_transaction_cheque: `${process.env.REACT_APP_API}/transaction_cheque_pdf`,
    notifications: `${process.env.REACT_APP_API}/notifications`,
    get_notifications: `${process.env.REACT_APP_API}/notifications?limit=10`,
    put_notifications: `${process.env.REACT_APP_API}/read_notifications`,
    register_notification_token: `${process.env.REACT_APP_API}/fcm_token`,
    account: `${process.env.REACT_APP_API}/account`,
    account_categories: `${process.env.REACT_APP_API}/account_categories`,
    profile: `${process.env.REACT_APP_API}/user/profile`,
    change_password: `${process.env.REACT_APP_API}/users/password`,
    transaction_products: `${process.env.REACT_APP_API}/transaction_products`,
    payment_methods: `${process.env.REACT_APP_API}/payment_methods`,
    get_countries: `${process.env.REACT_APP_API}/countries`,
    product_category: `${process.env.REACT_APP_API}/product_category`,
    attribute_templates: `${process.env.REACT_APP_API}/attribute_templates`,
    brands: `${process.env.REACT_APP_API}/product_brand`,
    transaction_journal: `${process.env.REACT_APP_API}/transaction_journal`,
    account_records: `${process.env.REACT_APP_API}/account_records`,
    transactions_service_accounts: `${process.env.REACT_APP_API}/transactions_service_accounts`,
    suppliers: `${process.env.REACT_APP_API}/suppliers`,
    suppliers_excel: `${process.env.REACT_APP_API}/suppliers/excel`,
    client_contacts: `${process.env.REACT_APP_API}/clients/contacts`,
    transfers: `${process.env.REACT_APP_API}/transfers`,
    transfers_excel: `${process.env.REACT_APP_API}/transfers/excel`,
    statuses: `${process.env.REACT_APP_API}/statuses`,
    payrolls: `${process.env.REACT_APP_API}/payrolls`,
    payrolls_excel: `${process.env.REACT_APP_API}/payrolls/excel`,
    expenses: `${process.env.REACT_APP_API}/expenses`,
    expense_operations_excel: `${process.env.REACT_APP_API}/expenses/operations/excel`,
    dictionaries: `${process.env.REACT_APP_API}/dictionaries`,
    main: `${process.env.REACT_APP_API}/main_page`,
    sales_reports: `${process.env.REACT_APP_API}/sales_reports`,
    sales_reports_daily: `${process.env.REACT_APP_API}/reports/sales/daily`,
    sales_reports_monthly: `${process.env.REACT_APP_API}/reports/sales/monthly`,
    sales_reports_recalc: `${process.env.REACT_APP_API}/reports/sales/daily/recalc-bulk`,
    fin_reports: `${process.env.REACT_APP_API}/financial_report`,
    cards: `${process.env.REACT_APP_API}/clientCards`,
    client_documents: `${process.env.REACT_APP_API}/clients/doc`,
    product_serial_numbest: `${process.env.REACT_APP_API}/product/serial`,
    status_roles: `${process.env.REACT_APP_API}/transaction_statuses2roles`,
    goods_movement: `${process.env.REACT_APP_API}/product/movement`,
    goods_movement_excel: `${process.env.REACT_APP_API}/product/movement/excel`,
    tracking_history: `${process.env.REACT_APP_API}/product/movement`,
    shipments: `${process.env.REACT_APP_API}/shipments`,
    shipments_excel: `${process.env.REACT_APP_API}/shipments/excel`,
    purchase_bills: `${process.env.REACT_APP_API}/purchase_bills`,
    purchase_bills_excel: `${process.env.REACT_APP_API}/purchase_bills/excel`,
    purchase_bills_operations_excel: `${process.env.REACT_APP_API}/purchase_bills/operations/excel`,
    track_movement: `${process.env.REACT_APP_API}/product/track_movement`,
    transfer_funds: `${process.env.REACT_APP_API}/transfer_funds`,
    client_debts: `${process.env.REACT_APP_API}/client_debts`,
    client_debt_operations: `${process.env.REACT_APP_API}/client_debt_operations`,
    cancel_client_debt_operations: `${process.env.REACT_APP_API}/cancel_client_debt_operations`,
    pay_client_debt: `${process.env.REACT_APP_API}/pay_client_debt`,
    supplier_transactions: `${process.env.REACT_APP_API}/supplier_transactions`,
    exchange_rates: `${process.env.REACT_APP_API}/exchange_rates`,
    exchange_rates_excel: `${process.env.REACT_APP_API}/exchange_rates/excel`,
    currencies: `${process.env.REACT_APP_API}/currencies`,
    get_product_stock_by_id: `${process.env.REACT_APP_API}/get_product_stock_by_id`,
    installment_lines: `${process.env.REACT_APP_API}/installment_lines`,
    installment_conditions: `${process.env.REACT_APP_API}/installment_conditions`,
    product_image: `${process.env.REACT_APP_API}/product_image`,
    installment_cards: `${process.env.REACT_APP_API}/installment_cards`,
    installment_cards_excel: `${process.env.REACT_APP_API}/installment_cards/excel`,
    installment_list: `${process.env.REACT_APP_API}/installment_list`,
    installment: `${process.env.REACT_APP_API}/installment`,
    installments_general_report: `${process.env.REACT_APP_API}/installments_general_report`,
    installment_schedule: `${process.env.REACT_APP_API}/installment_schedule`,
    installment_schedule_reschedule_preview: `${process.env.REACT_APP_API}/installment_schedule/reschedule/preview`,
    installment_schedule_reschedule_apply: `${process.env.REACT_APP_API}/installment_schedule/reschedule/apply`,
    installment_schedule_reschedule_rollback: `${process.env.REACT_APP_API}/installment_schedule/reschedule/rollback`,
    pay_installment: `${process.env.REACT_APP_API}/pay_installment`,
    installment_cashback: `${process.env.REACT_APP_API}/installment_cashback`,
    installment_cashback_history_excel: `${process.env.REACT_APP_API}/installment_cashback/history/excel`,
    client_installments_by_pan: `${process.env.REACT_APP_API}/client_installments_by_pan`,
    client_transactions: `${process.env.REACT_APP_API}/client_transactions`,
    installment_next_tranche: `${process.env.REACT_APP_API}/installment_next_tranche`,
    installment_list_download: `${process.env.REACT_APP_API}/installment_list/download`,
    installment_comments: (installmentId: number | string) =>
        `${process.env.REACT_APP_API}/installment/${installmentId}/comments`,
    installment_comment: (installmentId: number | string, commentId: string) =>
        `${process.env.REACT_APP_API}/installment/${installmentId}/comments/${commentId}`,
    activity_types: `${process.env.REACT_APP_API}/activity_types`,
    client_activity: `${process.env.REACT_APP_API}/client_activity`,
    inventory_adjustments: `${process.env.REACT_APP_API}/inventory_adjustments`,
    inventory_adjustments_excel: `${process.env.REACT_APP_API}/inventory_adjustments/excel`,
    message: `${process.env.REACT_APP_API}/sms/message`,
    sms_messages_excel: `${process.env.REACT_APP_API}/sms/message/excel`,
    template: `${process.env.REACT_APP_API}/sms/template`,
    template_excel: `${process.env.REACT_APP_API}/sms/template/excel`,
    contact_group: `${process.env.REACT_APP_API}/sms/contact_group`,
    contact_group_excel: `${process.env.REACT_APP_API}/sms/contact_group/excel`,
    contact_group_members: `${process.env.REACT_APP_API}/sms/contact_group_members`,
    installment_commission_cheque: `${process.env.REACT_APP_API}/installment/commission/cheque`,
    sms_plans: `${process.env.REACT_APP_API}/sms/plan`,
    sms_plans_excel: `${process.env.REACT_APP_API}/sms/plan/excel`,
    sms_reports: `${process.env.REACT_APP_API}/sms/report`,
    sms_balance: `${process.env.REACT_APP_API}/sms/balance`,
    crm_issues: `${process.env.REACT_APP_API}/crm/issues`,
    crm_issues_excel: `${process.env.REACT_APP_API}/crm/issues/excel`,
    crm_interactions: `${process.env.REACT_APP_API}/crm/interactions`,
    crm_interactions_excel: `${process.env.REACT_APP_API}/crm/interactions/excel`,
    crm_campaign: `${process.env.REACT_APP_API}/crm/campaigns`,
    crm_campaign_excel: `${process.env.REACT_APP_API}/crm/campaigns/excel`,
    cities: `${process.env.REACT_APP_API}/cities`,
    reconciliations: `${process.env.REACT_APP_API}/reconciliations`,
    interaction_types: `${process.env.REACT_APP_API}/crm/interaction_types`,
    owner_integrations: `${process.env.REACT_APP_API}/owner_integrations`,
    owner_integration_categories_summary: `${process.env.REACT_APP_API}/owner_integrations/categories/summary`,
    forgive_tranch_penalty: `${process.env.REACT_APP_API}/forgive_tranch_penalty`,
    client_statuses: `${process.env.REACT_APP_API}/client_statuses`,
    client_lead_qualities: `${process.env.REACT_APP_API}/client_lead_qualities`,
    order_requests: `${process.env.REACT_APP_API}/order_requests`,
    order_requests_excel: `${process.env.REACT_APP_API}/order_requests/excel`,
    credit_potential: `${process.env.REACT_APP_API}/clients/credit_potential`,
    client_files: `${process.env.REACT_APP_API}/clients/files`,
    graphql: `${process.env.REACT_APP_API}/graph/query`,
    banners: `${process.env.REACT_APP_API}/shop/banners`,
    shop_products: `${process.env.REACT_APP_API}/shop/products`,
    shop_settings: `${process.env.REACT_APP_API}/shop/settings`,
    shop_brands: `${process.env.REACT_APP_API}/shop/brands`,
    shop_categories: `${process.env.REACT_APP_API}/shop/categories`,
    logs: `${process.env.REACT_APP_API}/logs`,
    transactions_user_report: `${process.env.REACT_APP_API}/transactions/user_report`,
    cash_sessions: `${process.env.REACT_APP_API}/cash-sessions`,
    cash_sessions_excel: `${process.env.REACT_APP_API}/cash-sessions/excel`,
    cash_session_open: `${process.env.REACT_APP_API}/cash-sessions/open`,
    cash_session_current: `${process.env.REACT_APP_API}/cash-sessions/current`,
    replenishment_candidates: `${process.env.REACT_APP_API}/replenishment/candidates`,
    get_clients_active_short: `${process.env.REACT_APP_API}/clients/active_short`,
    get_products_active_short: `${process.env.REACT_APP_API}/products/active_short`,
    client_blacklists: `${process.env.REACT_APP_API}/clients/blacklists`,
    installment_doc: `${process.env.REACT_APP_API}/installment_doc/files`,
    chat_stream: `${process.env.REACT_APP_API}/chat/stream`,
    chat_speech_to_text: `${process.env.REACT_APP_API}/chat/speech-to-text`,
    product_ai_fill: `${process.env.REACT_APP_API}/product/ai-fill`,
    product_ai_suggest_images: `${process.env.REACT_APP_API}/product/ai-suggest-images`,
    product_fetch_image_url: `${process.env.REACT_APP_API}/product/fetch-image-url`,
    installment_doc_zip: `${process.env.REACT_APP_API}/installment_doc/zip`,
    client_check_duplicates: `${process.env.REACT_APP_API}/clients/check_duplicates`,
    client_search_duplicates: `${process.env.REACT_APP_API}/clients/search_duplicates`,
    client_search_all_duplicates: `${process.env.REACT_APP_API}/clients/search_all_duplicates`,
    client_merge: `${process.env.REACT_APP_API}/clients/merge`,
};
